import { createAction } from '@reduxjs/toolkit';

export const mediaDevicesChangeStarted = createAction<{ devicechangeEvents: number }>(
  'userMedia/mediaDevicesChangeStarted'
);
